WL.registerComponent('hitmarker', {
    player: {type: WL.Type.Object},
}, {
    init: function() {
        this.object.getComponent('mesh').active = false;
        this.playerPosition = new Float32Array(3);
        this.snd = this.object.getComponent('howler-audio-source');
    },
    showHitmarker: function(position) {
        this.snd.play();
        this.object.setTranslationWorld(position);
        this.object.getComponent('mesh').active = true;
        this.player.getTranslationWorld(this.playerPosition);
        this.object.lookAt(this.playerPosition, [0, 1, 0]);
    },
    hideHitmarker: function() {
        this.object.getComponent('mesh').active = false;
        this.object.resetTranslation();
    },
});
